/* ===== Anadita Luxe — collection filters ===== */
(function () {
  'use strict';
  var form = document.querySelector('[data-facets]');
  if (!form) return;
  var $$ = function (s) { return Array.prototype.slice.call(form.querySelectorAll(s)); };
  var applyTimer = null;

  function buildFacetParams() {
    var params = new URLSearchParams();
    Array.prototype.forEach.call(form.elements, function (el) {
      if (!el || !el.name || el.disabled) return;

      var tag = (el.tagName || '').toUpperCase();
      var type = (el.type || '').toLowerCase();

      if ((type === 'checkbox' || type === 'radio') && !el.checked) return;
      if (tag === 'SELECT' && el.multiple) {
        Array.prototype.forEach.call(el.options, function (opt) {
          if (opt.selected && opt.value) params.append(el.name, opt.value);
        });
        return;
      }

      var value = (el.value == null) ? '' : String(el.value).trim();
      if (!value) return;
      params.append(el.name, value);
    });
    return params;
  }

  function applyFacets() {
    var next = new URL(window.location.href);
    var params = buildFacetParams();
    next.search = params.toString();
    var target = next.toString();
    if (target === window.location.href) return;
    window.location.assign(target);
  }

  function queueApply() {
    if (applyTimer) window.clearTimeout(applyTimer);
    // Coalesce quick consecutive changes (for fast tap/click interactions).
    applyTimer = window.setTimeout(applyFacets, 60);
  }

  $$('[data-facet-auto]').forEach(function (el) {
    el.addEventListener('change', queueApply);
    if ((el.type || '').toLowerCase() === 'number') {
      el.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') {
          event.preventDefault();
          queueApply();
        }
      });
    }
  });

  form.addEventListener('submit', function (event) {
    event.preventDefault();
    queueApply();
  });

  var panel = form.querySelector('[data-facets-panel]');
  var toggle = form.querySelector('[data-facets-toggle]');
  var close = form.querySelector('[data-facets-close]');
  if (toggle && panel) toggle.addEventListener('click', function () { panel.classList.add('is-open'); document.body.style.overflow = 'hidden'; });
  if (close && panel) close.addEventListener('click', function () { panel.classList.remove('is-open'); document.body.style.overflow = ''; });
})();
